import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/console/:type/levels";


export const member = {
    levels: {
        gets(data){
            return axios.get(`${url.replace(":type", "member")}`, data).then(result => result.data);
        },
        get(data){
            return axios.get(`${url.replace(":type", "member")}/${data._id}`).then(result => result.data);
        },
        post(data){
            return axios.post(`${url.replace(":type", "member")}`, data).then(result => result.data);
        },
        put(data){
            return axios.put(`${url.replace(":type", "member")}/${data._id}`, data).then(result => result.data);
        },
        delete(data){
            return axios.delete(`${url.replace(":type", "member")}/${data._id}`).then(result => result.data);
        }
    }
}
